import { render, staticRenderFns } from "./AllReservationSubmissions.vue?vue&type=template&id=b344c4c2&scoped=true&"
import script from "./AllReservationSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllReservationSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllReservationSubmissions.vue?vue&type=style&index=0&id=b344c4c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b344c4c2",
  null
  
)

export default component.exports